import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Alert from "react-bootstrap/Alert";
import "./css/RealTimeWaveForm.css";
import Form from "react-bootstrap/Form";
import WaveformAnalysisAPI from "../../../../../api/WaveformApi";
import Cookies from "js-cookie";
import ReactLoading from "react-loading";
import TrendingAnalysisAPI from "../../../../../api/TrendingAnalysisApi";
import Dropdown from "react-dropdown";

export default function RTWaveform({ tabData, setTabData, setPlotsOrder }) {
    const token = Cookies.get("Session");
    const portalToken = Cookies.get("portalSession");

    // extarcting from redux slice
    const { selectedCustomer, selectedFacility, selectedEquipment, equipmentTimezone, showSELMenu } = useSelector(
        (state) => state.equipmentsPortfolio
    );
    const selectedVoltageType = useSelector((state) => state.voltageType.selectedVoltageType);

    // RealTime Waveform Plot Hooks
    const [realTimeWaveformAlert, setRealTimeWaveformAlert] = useState({
        color: "blue",
        text: "",
        show: false,
    });

    {
        /************************************ RealTime Waveform Tab fuctions **************************************************************/
    }
    useEffect(() => {
        if (tabData.showPlot && tabData.plotMetaData.selectedEquipment == selectedEquipment) {
            onRealTimeWaveformPlotButtonClick();
        }
    }, [selectedVoltageType]);

    const onRealTimeWaveformPlotButtonClick = async () => {
        if (!selectedFacility) {
            setRealTimeWaveformAlert({
                color: "primary",
                text: "Select a Facility",
                show: true,
            });
        } else if (!selectedEquipment) {
            setRealTimeWaveformAlert({
                color: "primary",
                text: "Select an Equipment",
                show: true,
            });
        } else {
            clearInterval(window.waveformMeteringId);
            setRealTimeWaveformAlert({ ...realTimeWaveformAlert, show: false });
            setPlotsOrder({
                rtWaveform: 1,
                waveform: 2,
            });
            setTabData((prevState) => {
                return {
                    ...prevState,
                    plotData: {
                        Np_I_peak: { x: "", y: "" },
                        Time: [],
                        I1: [],
                        I2: [],
                        I3: [],
                        V1: [],
                        V2: [],
                        V3: [],
                        analysis: {},
                    },
                    isPlotLoading: true,
                    plotMetaData: {
                        selectedEquipment: selectedEquipment,
                        selectedVoltageType: selectedVoltageType,
                        equipmentTimezone: equipmentTimezone.value,
                    },
                    showPlot: true,
                };
            });

            WaveformAnalysisAPI.getRTPlotData(token, selectedEquipment.value, selectedVoltageType.value)
                .then((response) => {
                    if (response.status === 204) {
                        setTabData((prevState) => {
                            return {
                                ...prevState,
                                isPlotLoading: false,
                            };
                        });

                        setRealTimeWaveformAlert({
                            color: "primary",
                            text: "No Data Found",
                            show: true,
                        });
                    } else if (response.status === 200) {
                        setTabData((prevState) => {
                            return {
                                ...prevState,
                                plotData: response.data.content.plot_data,
                                showPlot: true,
                                isPlotLoading: false,
                            };
                        });
                        setPlotsOrder({
                            rtWaveform: 1,
                            waveform: 2,
                        });
                    }
                })
                .catch((error) => {
                    setTabData((prevState) => {
                        return {
                            ...prevState,
                            isPlotLoading: false,
                        };
                    });
                    console.log(error);
                });
        }
    };

    return (
        <div>
            <Row>
                <Col>
                    <h2 className="margin-top-10">Real-time Waveforms</h2>
                </Col>
            </Row>
            <br></br>
            <Row>
                <Col className="col-2">
                    {tabData.isPlotLoading ? (
                        <ReactLoading type="bars" color="#007bff" height={50} width={50} />
                    ) : (
                        <Button variant="primary" onClick={onRealTimeWaveformPlotButtonClick} className="plot_button">
                            Plot
                        </Button>
                    )}
                </Col>
                <Col className="col-5 waveformAlert">
                    <Alert
                        variant={realTimeWaveformAlert.color}
                        show={realTimeWaveformAlert.show}
                        onClose={() =>
                            setRealTimeWaveformAlert({
                                ...realTimeWaveformAlert,
                                show: false,
                            })
                        }
                        dismissible
                    >
                        {realTimeWaveformAlert.text}
                    </Alert>
                </Col>
            </Row>
        </div>
    );
}
